module.exports = __webpack_public_path__ + "static/media/influencer-min.39d53880.jpg";